module.exports = __webpack_public_path__ + "img/cross-black.a594ab60.svg";